// 'fuel_card', 'card' нету в pdf. Указания изменились чтобы выводить предупреждение только на нал без чека.
const PAYMENT_WITH_CHECK = ['cash_check', 'card_check', 'fuel_card', 'card'] as const

export const isExpenseInPdf = (paymentType?: string): boolean =>
  PAYMENT_WITH_CHECK.includes(
    paymentType as (typeof PAYMENT_WITH_CHECK)[number]
  )
